module.exports = __webpack_public_path__ + "static/img/qr_code_1.7514cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_code_1.png
// module id = u+gf
// module chunks = 16